import { DateTime, Settings } from "luxon";

/**
 * Convert a date from a date picker to a Luxon DateTime in the configured timezone.
 * Handles moment objects, native Date objects, and Luxon DateTime objects.
 * 
 * @param {*} date - The date from the picker (moment, Date, or DateTime)
 * @returns {DateTime|null} DateTime in the configured timezone, or null if invalid
 */
export const getDateTimeFromPicker = (date) => {
  if (!date) return null;

  if (date._isAMomentObject) {
    // Bootstrap datepicker returns a moment object
    // Convert to native Date, then to Luxon DateTime in the configured timezone
    return DateTime.fromJSDate(date.toDate(), { zone: Settings.defaultZone });
  }
  
  if (date instanceof Date) {
    // Native Date object - convert to Luxon DateTime in the configured timezone
    return DateTime.fromJSDate(date, { zone: Settings.defaultZone });
  }
  
  if (date instanceof DateTime) {
    // Already a Luxon DateTime - just ensure it's in the configured timezone
    return date.setZone(Settings.defaultZone);
  }
  
  return null;
};

/**
 * Parse a time string input to a Luxon DateTime in the configured timezone.
 * 
 * @param {string} value - The time string (e.g., "14:30")
 * @returns {DateTime|null} DateTime in the configured timezone, or null if invalid
 */
export const getTimeFromInput = (value) => {
  if (!value) return null;
  
  const timeStr = value.trim();
  if (!timeStr) return null;
  
  const parsedTime = DateTime.fromFormat(timeStr, "HH:mm", { 
    zone: Settings.defaultZone 
  });
  
  return parsedTime.isValid ? parsedTime : null;
};
